export{ContextRequestEvent as ContextEvent}from"./lib/context-request-event.js";export{createContext}from"./lib/create-context.js";export{ContextConsumer}from"./lib/controllers/context-consumer.js";export{ContextProvider}from"./lib/controllers/context-provider.js";export{ContextRoot}from"./lib/context-root.js";import{provide as o}from"./lib/decorators/provide.js";export{provide}from"./lib/decorators/provide.js";import{consume as t}from"./lib/decorators/consume.js";export{consume}from"./lib/decorators/consume.js";
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const e=o,r=t;export{r as contextProvided,e as contextProvider};
//# sourceMappingURL=index.js.map
